// Styles
import { AuthorImg, AuthorName, AuthorOtherMaterials, WrapAuthor } from './style';

import { useTranslations } from 'languages';
import { useProContext } from 'store/ProReducer/useProContext';
import { useLink } from 'utils/hooks/useLink';

type authorNameType = {
  full_name?: string;
};

type authorSlagType = {
  slug?: string;
};

export const ArticleAuthor = (props: { data: any }) => {
  const { data = {} }: { data: any } = props;

  const { isCosmetology, isNails, isPermanent } = useProContext();

  const { authorName = { full_name: '' }, author_image = '', authorSlug = '' } = data;

  const linkPath = useLink();

  const authorLink = `${linkPath}/columnist/${authorSlug || ''}`;

  const t = useTranslations();

  const defaultLocalImage = isCosmetology
    ? '/images/News/cosmetology_post_icon.webp'
    : isPermanent
      ? '/images/News/permanent.webp'
      : isNails
        ? '/images/News/nails.webp'
        : '/images/News/photo_2022-11-09_13-07-31.webp';

  return (
    <WrapAuthor className="authorContainer">
      <AuthorImg
        priority
        src={author_image.length === 0 ? defaultLocalImage : author_image}
      />
      <AuthorName>{authorName?.full_name}</AuthorName>
      <AuthorOtherMaterials href={authorLink}>
        {t('Article.OtherAuthorsMaterials')}
      </AuthorOtherMaterials>
    </WrapAuthor>
  );
};
